module.exports = __webpack_public_path__ + "img/life-at-ommax.4f3aa159.jpg";